<section class="lum-c-channel-custom-fields">
  <div class="flex justify-content-between">
    <header>
      <h5>Custom Properties</h5>
      <small
        >Set custom order properties to be included when pushing orders to a
        third-party OMS.</small
      >
    </header>
    <button
      class="
        lum-button lum-button--secondary lum-c-channel-custom-fields__add-button
      "
      type="button"
      (click)="onAddCustomField()"
    >
      <i class="fas fa-plus"></i> Add Custom Property
    </button>
  </div>
  <p></p>
  <div
    *ngIf="pushCustomFieldsControl.controls.length; else emptyCustomFields"
    class="form"
    [formGroup]="form"
  >
    <table class="lum-table lum-table--classic">
      <thead>
        <th>Custom Property Name</th>
        <th>Custom Property Value</th>
        <th></th>
      </thead>
      <tbody formGroupName="pushOrdersToOmsOptions">
        <ng-container formArrayName="pushCustomFields">
          <ng-container
            *ngFor="
              let customField of pushCustomFieldsControl.controls;
              let i = index
            "
          >
            <tr [formGroupName]="i">
              <td>
                <input type="text" class="lum-input" formControlName="key" />
              </td>
              <td>
                <input type="text" class="lum-input" formControlName="value" />
              </td>
              <td>
                <button
                  type="button"
                  class="lum-button lum-button--transparent text-red-500 remove-item--button"
                  (click)="onRemoveCustomField(i)"
                >
                  <i class="fas fa-times"></i>
                </button>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
  <ng-template #emptyCustomFields>
    <p class="text-center mt-5"><em>No custom properties configured.</em></p>
  </ng-template>
</section>
